App.filter('dateFormatterLongNameMonth', ['moment', function (moment) {
    const months = [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        'września',
        'października',
        'listopada',
        'grudnia'
    ];

    return function (dateString) {
        dateString = dateString || '';
        if (dateString) {
            let date = moment(dateString);
            return `${date.date()} ${months[date.month()]}`;
        }

        return '';
    };
}]);
